import { uid } from 'uid'
import {BaseWidgetModel} from '~/site/model/models/base'
import {hasOwn} from '~/utils'
import { ModuleNameEnum, ModuleTitleEnum, WidgetModelNames } from '~/enums/siteEnum'
import {generateDefaultBackground, generateDefaultNavModel} from "~/site/model/helper"
import {DefaultTemplate} from "~/enums/templateEnum";
import {LangIdMap} from "~/config/language";
import { DefaultImage } from '~/enums/defaultImageEnum'

export class DialogItemWidgetModel extends BaseWidgetModel {
  static moduleClass = WidgetModelNames.DialogItemWidgetModel
  static __menuInfo = {
    id: uid(),
    title: ModuleTitleEnum.DialogItem,
    model: DialogItemWidgetModel,
    draggable: true
  }

  constructor(options) {
    super(options)
    this.name = DialogItemWidgetModel.moduleClass
    this.menuName = hasOwn(options, 'menuName', '', '弹窗1')
    this.background = hasOwn(options, 'background', '', generateDefaultBackground({ backgroundColor: '#f0f0f0' }))
    this.radius = hasOwn(options, 'radius', '', 27)
    this.titleVisible = hasOwn(options, 'titleVisible', '', true)
    this.describeVisible = hasOwn(options, 'describeVisible', '', true)
    this.buttonVisible = hasOwn(options, 'buttonVisible', '', true)
    this.buttonName = hasOwn(options, 'buttonName', '', LangIdMap.DialogCollectionButton)
    this.immediate = hasOwn(options, 'immediate', '', false)
    this.showType = hasOwn(options, 'showType', '', 1)

    const __getListItem = () => {
      return {
        id: uid(),
        background: generateDefaultBackground({ backgroundImage: DefaultImage.dialogBlockImage }),
        describe: `<p class="ql-align-center">${LangIdMap.DialogBlockItemDesc}</p>`
      }
    }

    const __getChildrenItem = () => {
      return {
        id: uid(),
        title: DefaultTemplate.dialog.title,
        describe: DefaultTemplate.dialog.describe,
        list: [
          __getListItem(),
          __getListItem(),
          __getListItem()
        ],
        ...generateDefaultNavModel()
      }
    }

    this.children = hasOwn(options, 'children', '', [__getChildrenItem()])
    this.__onMenuSelected = ({ child, childIndex }, context) => {
      context.$store.commit('site/SET_CURRENT_VISIBLE_DIALOG_ID', child.id)
      context.$nextTick(() => {
        document.querySelector('.edit-content__center--wrapper').scrollTop = 0
      })
    }
    this.__addItem = () => {
      this.children.push(__getChildrenItem())
    }
    this.__addListItem = (childrenIndex) => {
      this.children[childrenIndex].list.push(__getListItem())
    }
    this.getMenuInfo = () => DialogItemWidgetModel.__menuInfo
  }
}

export class DialogCollectionWidgetModel extends BaseWidgetModel {
  static moduleClass = WidgetModelNames.DialogCollectionWidgetModel
  static registerModel = {
    DialogItemWidgetModel
  }

  constructor(options = {}) {
    super(options)
    this.name = DialogCollectionWidgetModel.moduleClass
    this.moduleName = ModuleNameEnum.DialogCollection

    this.__getItemMenuName = () => {
      const numberArr = this.children.map(item => item.menuName[item.menuName.length - 1])
      const max = !numberArr.length ? 1 : Math.max(...numberArr) + 1
      return `弹窗${max}`
    }

    this.children = []
    if (Array.isArray(options?.children)) {
      options.children.forEach(item => {
        const Model = DialogCollectionWidgetModel.registerModel[item.name]
        if (typeof Model === 'function') {
          this.children.push(new Model(item))
        }
      })
    } else {
      this.children = [
        new DialogItemWidgetModel({ menuName: this.__getItemMenuName() })
      ]
    }

    this.__refresh = null
    this.__refreshRichText = null
    this.addMenuMethod = () => {
      this.children.push(new DialogItemWidgetModel({ menuName: this.__getItemMenuName() }))
    }

    this.__getLang = () => {
      const { children } = this
      return {
        children: children.map(item => {
          return {
            buttonName: item.buttonName,
            children: item.children.map(child => {
              return {
                title: child.title,
                describe: child.describe,
                list: child.list.map(listItem => {
                  return {
                    describe: listItem.describe
                  }
                })
              }
            })
          }
        })
      }
    }

    this.getMenuInfo = () => {
      return {
        id: this.id,
        title: ModuleTitleEnum.DialogCollection,
        icon: 'icon-chuangkou',
        name: this.name,
        model: this.constructor,
        draggable: true,
        isDefault: false,
        disableSelectToView: true
      }
    }
  }
}
